import { login } from '@/api/login'
import { encrypt } from '@/utils/encryp.js';
import { onlyLanguage } from "@/utils/storage";
import { getToken, setToken, removeToken,setepayToken,getts, getCompanyId, removeCompanyId,  getversion,removeIV, removeepayToken} from '@/utils/auth'
import { startLoading, endLoading } from "@/utils/ruoyi";
const user = {
  state: {
    token: getToken(),
    userInfo:JSON.parse(window.localStorage.getItem('userInfo')||'{}'),
    name: JSON.parse(window.localStorage.getItem('name')||'null'),
    avatar: '',
    roles: [],
    permissions: [],
    companyid: getCompanyId(),
    companyconfig: {},
    ts: getts(),
    version: getversion()
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
      window.localStorage.setItem("name", JSON.stringify(name));
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_COMPANYID: (state, companyid) => {
      state.companyid = companyid
    },
    SET_COMPANYCONFIG: (state, companyconfig) => {
      state.companyconfig = companyconfig
    },
    SET_TS: (state, ts) => {
      state.ts = ts
    },
    SET_VERSION: (state, version) => {
      state.version = version
    },
    REMOVE_USERINFO(state){
      state.userInfo = {}
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = {...state.userInfo,...userInfo}
      window.localStorage.setItem("userInfo", JSON.stringify(state.userInfo));
    }
  },

  actions: {
    // 登录
    Login({ commit }, code) {
      const msgCode = code.trim()
      return new Promise((resolve, reject) => {
        startLoading()
        login({ msgCode:msgCode}).then(res => {
          if (res.code === 0) {
            endLoading()
            // setepayToken(res.data.token)
            // commit('SET_TOKEN', res.data.token)
            resolve()
          }

        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_COMPANYID', '')
        commit('SET_ROLES', [])
        window.localStorage.removeItem('SET_KEY')
        window.localStorage.removeItem('SET_V')
        window.localStorage.removeItem('sasstoken')
        localStorage.removeItem('pwdtoken')
        commit('SET_AVATAR', '')
        removeToken()
        removeCompanyId()
        // removekey()
        removeepayToken()
        removeIV()
        resolve()
        onlyLanguage()
        sessionStorage.clear()
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_COMPANYID', '')
        removeToken()
        removeCompanyId()
        resolve()
        removekey()
        removeIV()
        removeepayToken()
        localStorage.removeItem('pwdtoken')
        window.localStorage.removeItem('sasstoken')
        onlyLanguage()
        sessionStorage.clear()
      })
    },

  },
  getters: {
    getcompanyinfo: (state) => {
      return state.companyconfig
    },
  }

}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js